// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import { SchemaModifier } from '../types';
import { generateSchema } from '../SchemaGeneration';

const findListingBlock = (blocks: Record<string, any>): string | null => {
  for (const blockId in blocks) {
    const block = blocks[blockId];
    if (block['@type'] === 'listing') {
      return blockId;
    }
    if (block?.data?.blocks) {
      const nestedId = findListingBlock(block.data.blocks);
      if (nestedId) {
        return nestedId;
      }
    }
  }
  return null;
};

const listingItems = (content: Content, id: string, state: any): Content[] => {
  const subrequestID = content?.UID ? `${content?.UID}-${id}` : id;
  return state.querystringsearch.subrequests?.[subrequestID]?.items || [];
};

const documentModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  const is_filter_page = content?.seo_filter_page;
  const id = findListingBlock(content?.blocks || {});

  if (is_filter_page && id) {
    main['@type'] = 'ItemList';
    main['itemListElement'] = listingItems(content, id, state).map((item) =>
      generateSchema({
        type: item['@type'],
        content: item,
        state,
        partial: true,
      }),
    );
  }
};

export default documentModifier;
